import { Link } from '@tanstack/react-router';
import Icon from '@mdi/react';
import { mdiLogout } from '@mdi/js';

const LogoutMenuItem = () => {
    return (
        <Link
            onClick={() => $('body').removeClass('is-nav-mobile-active')}
            to='/logga-ut'
            className='btn-none nav-link w-100'
        >
            <Icon
                path={mdiLogout}
                className='mdi mr-2'
            />
            Logga ut
        </Link>
    );
};

export default LogoutMenuItem;
